module.exports = __webpack_public_path__ + "static/media/horse-with-mask.a993c1a0.png";